import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { langState } from "../store/langState";

/**
 * 어드민 미리보기 언어 전환 수신.
 * 어드민이 언어 탭(ko/en)을 바꾸면 postMessage(CMS_SET_LANG, lang: 'KR'|'EN')를 보내고,
 * 이 훅이 홈페이지의 langState를 그 언어로 전환한다. (CMS 미리보기 전용)
 */
export function useCmsPreviewLang() {
  const setLangValue = useSetRecoilState(langState);

  useEffect(() => {
    const handler = (e) => {
      if (
        e.data?.type === "CMS_SET_LANG" &&
        (e.data.lang === "KR" || e.data.lang === "EN")
      ) {
        setLangValue(e.data.lang);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [setLangValue]);
}
